<template>
    <div class="health-content">
        <div class="health-list">
            <div class="health-item" v-show="pedometer">
                <div class="item-name">
                    <img src="../assets/images/step.png" alt="">
                    <div class="health-name">步数</div>
                </div>
                <div class="item-num">{{pedometer}}<span>步</span></div>
                <div class="time">{{beatHeart_time}}</div>
            </div>
            <div class="health-item" v-show="heartRate">
                <div class="item-name">
                    <img src="../assets/images/heart-rote.png" alt="">
                    <div class="health-name">心率</div>
                </div>
                <div class="item-num">{{heartRate}}<span>bmp</span></div>
                <div class="time">{{health_time}}</div>
            </div>
            <!-- <div class="special">
                <div class="special-head">
                    <div class="item-name">
                        <img src="../assets/images/sleep.png" alt="">
                        <div class="health-name">睡眠</div>
                    </div>
                    <div class="time">4月5日 15:06</div>
                </div>
                <div class="sleep-list">
                    <div class="sleep-item">
                        <div class="item-box">
                            <div class="special-name">总计</div>
                            <div class="item-time">8<span>时</span>22<span>分</span></div>
                        </div>                        
                    </div>
                    <div class="sleep-item">
                        <div class="item-box">
                            <div class="special-name">深睡</div>
                            <div class="item-time">7<span>时</span>10<span>分</span></div>
                        </div>                        
                    </div>
                    <div class="sleep-item">
                        <div class="item-box">
                            <div class="special-name">浅睡</div>
                            <div class="item-time">1<span>时</span>12<span>分</span></div>
                        </div>                        
                    </div>
                </div>
            </div> -->
            <div class="special" v-show="sdp">
                <div class="special-head">
                    <div class="item-name">
                        <img src="../assets/images/blood-pressure.png" alt="">
                        <div class="health-name">血压</div>
                    </div>
                    <div class="time">{{health_time}}</div>
                </div>
                <div class="pressure-list">
                    <div class="pressure-item">
                        <div class="item-box">
                            <div class="special-name">收缩压</div>
                            <div class="item-time">{{sdp}}<span>mmHg</span></div> 
                        </div>                        
                    </div>
                    <div class="pressure-item">
                        <div class="item-box">
                            <div class="special-name">舒张压</div>
                            <div class="item-time">{{dbp}}<span>mmHg</span></div>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="health-item" v-show="oxygen">
                <div class="item-name">
                    <img src="../assets/images/blood-oxygen.png" alt="">
                    <div class="health-name">血氧</div>
                </div>
                <div class="item-num">{{oxygen}}<span>%</span></div>
                <div class="time">{{health_time}}</div>
            </div>
            <div class="health-item" v-show="bloodSugar&&bloodSugar!='0.0'">
                <div class="item-name">
                    <img src="../assets/images/blood-glucose.png" alt="">
                    <div class="health-name">血糖</div>
                </div>
                <div class="item-num">{{bloodSugar}}<span>mmol/L</span></div>
                <div class="time">{{health_time}}</div>
            </div>
            <div class="health-item" v-show="temperature">
                <div class="item-name">
                    <img src="../assets/images/temperature.png" alt="">
                    <div class="health-name">体温</div>
                </div>
                <div class="item-num">{{temperature}}<span>℃</span></div>
                <div class="time">{{health_time}}</div>
            </div>
            <!-- <div class="health-item">
                <div class="item-name">
                    <img src="../assets/images/ecg.png" alt="">
                    <div class="health-name">心电</div>
                </div>
                <div class="item-details">点击查看详情</div>
                <div class="time">4月5日 15:06</div>
            </div> -->
        </div>
    </div>
</template>
<script>
import {health_data,beatHeart_data} from '../api/my'
export default {
    data() {
        return {
            imei:'',
            pedometer:'',
            heartRate:'',
            dbp:'',
            sdp:'',
            oxygen:'',
            bloodSugar:'',
            temperature:'',
            health_time:'',
            beatHeart_time:'',
        };
    },
    computed: {},
    methods: {
        healthData(){
            health_data(this.imei).then(res=>{
                if(res.status==200){
                    if(res.data.healthData){
                        this.bloodSugar=res.data.healthData.bloodSugar;
                        this.dbp=res.data.healthData.dbp;
                        this.sdp=res.data.healthData.sdp;
                        this.heartRate=res.data.healthData.heartRate;
                        this.oxygen=res.data.healthData.oxygen;
                        this.temperature=res.data.healthData.temperature;
                        this.health_time=res.data.healthData.upload_time;
                    }                                       
                }
            })
        },
        beatHeartData(){
            beatHeart_data(this.imei).then(res=>{
                if(res.status==200){
                    this.pedometer=res.data.healthData.pedometer;
                    this.beatHeart_time=res.data.healthData.upload_time;
                }
            })
        }
    },
    created() {
        let imei=localStorage.getItem('imei')
        this.imei=imei;
        this.healthData()
        this.beatHeartData() 
    },
};
</script>
<style lang='less' scoped>
.health-content{
    padding: 16px;
}
.health-item{
    background-color: #fff;
    border-radius: 10px;
    padding: 16px 12px;
    margin-bottom: 10px;
    height: 28px;
}
.item-name{
    height: 28px;
    display: flex;
    justify-content: flex-start;
    float: left;
    width: 30%;
}
.item-name img{
    display: block;
    height: 28px;
    margin-right: 8px;
}
.health-name{
    height: 28px;
    line-height: 28px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
}
.item-num{
    height: 20px;
    margin-top: 4px;
    line-height: 20px;
    font-size: 20px;
    font-weight: 900;
    color: #333;
    float: left;
    font-family: 'avenir';
}
.item-num span{
    height: 12px;
    line-height: 12px;
    color: #999999;
    font-size: 12px;
    margin-top: 12px;
    font-weight: 500;
    margin-left: 3px;
}
.time{
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #999;
    float: right;
}
.item-details{
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    color: #01D6D6;
    font-weight: 500;
    float: left;
}
.special{
    background-color: #fff;
    border-radius: 10px;
    padding: 0px 12px;
    margin-bottom: 10px;
}
.special-head{
    padding: 16px 0px;
    height: 28px;
}
.sleep-list{
    display: flex;
    justify-content: space-between;
    padding-bottom: 12px;
}
.sleep-item{
    background-color: #FBFCFC;
    border-radius: 10px;
    width: 32%;
}
.item-box{
    padding: 12px;
}
.special-name{
    height: 12px;
    line-height: 12px;
    font-weight: 500;
    color: #333;
    font-size: 12px;
    padding-bottom: 8px;
}
.item-time{
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    font-weight: 600;
    color: #333;
    font-family: 'avenir';
}
.item-time span{
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #999999;
    margin-top: 8px;
    margin-left: 3px;
    margin-right: 3px;
}
.pressure-list{
    display: flex;
    justify-content: space-between;
    padding-bottom: 12px;
}
.pressure-item{
    width: 48%;
    background-color: #FBFCFC;
}
</style>